import React, { useCallback, useState } from 'react';
import { ExpandIcon } from 'lucide-react';
import { lookInside } from '../data/content';
import { ImageSlot } from './ImageSlot';
import { Lightbox } from './Lightbox';
import { SectionHeading } from './SectionHeading';
type LookInsideSectionProps = {
  pageImages: string[];
};
export function LookInsideSection({
  pageImages
}: LookInsideSectionProps) {
  const [active, setActive] = useState<number | null>(null);
  const close = useCallback(() => setActive(null), []);
  return <section id="look-inside" aria-labelledby="look-title" className="scroll-mt-4 bg-teal py-12 md:py-20" data-id="element-119" data-mp="1b7ghfh9h28ir">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-120" data-mp="1p6zos7uglfu0">
        <SectionHeading id="look-title" tone="dark" eyebrow={lookInside.eyebrow} title={lookInside.title} data-id="element-121" data-mp="1k96h1adicdrm" />
        <p className="mt-3 text-center text-[13px] text-white/70" data-id="element-122" data-mp="3qze20tm25w43">{lookInside.hint}</p>
      </div>

      <ul className="no-scrollbar mx-auto mt-8 flex max-w-page snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-5 px-5 pb-2 md:mt-10 md:gap-4 md:scroll-px-8 md:px-8" aria-label="Sample pages" data-id="element-123" data-mp="3m0t2yxijlih8">
        {pageImages.map((url, i) => <li key={lookInside.captions[i]} className="w-[64%] shrink-0 snap-start sm:w-[40%] md:w-[28%] lg:w-[21%]" data-id="element-124" data-mp="3g15p9avqqdfv" data-mpi={i}>
            <button type="button" onClick={() => setActive(i)} className="group block w-full text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" aria-label={`Open full size: ${lookInside.captions[i]}`} data-id="element-125" data-mp="3l0ido029fskk">
              <div className="relative aspect-[9/16] overflow-hidden rounded-xl bg-teal-dark" data-id="element-126" data-mp="7n6vmfw8r45j">
                <ImageSlot url={url} alt={lookInside.captions[i]} slotName={`pageImages[${i}]`} data-id="element-127" data-mp="cmt7om0c2ecr" />
                <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-orange text-white transition-transform duration-150 ease-out group-hover:scale-105" data-id="element-128" data-mp="29flat77ehui9">
                  <ExpandIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="26cf6g1zfhngf" />
                </span>
              </div>
              <p className="mt-3 text-[14px] font-medium text-white" data-id="element-130" data-mp="21f6tqgx1ubmk">
                <span className="mr-2 font-display font-extrabold text-gold" data-id="element-131" data-mp="2gbxmi7c7wp37">{String(i + 1).padStart(2, '0')}</span>
                {lookInside.captions[i]}
              </p>
            </button>
          </li>)}
      </ul>

      <Lightbox images={pageImages} captions={lookInside.captions} index={active} onClose={close} onChange={setActive} data-id="element-132" data-mp="2parrakzpclru" />
    </section>;
}